/**
 * getParsedJsonState
 * helper function to get the json to be set
 */
export const getParsedJsonState = (tableValue: string) => {
  let jsonTableValue;
  try {
    jsonTableValue = JSON.parse(tableValue);
    return { isJsonValid: true, jsonTableValue };
  } catch (error) {
    jsonTableValue = {};
    return { isJsonValid: false, jsonTableValue };
  }
};
